import _ from 'lodash';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import api from '../../../../scripts/api';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import { VehicleTypeEnum } from '../../../../scripts/core/vehicleType/constants';
import environment from '../../../../scripts/environment';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class CompetitorsFilterFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const typeFilter = {
            name: 'type',
            position: 2,
            visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterStoreType),
            fields: [{
                title: translate('Common.TypeOfStore'),
                name: 'type',
                dataSource: _.map(environment.get('CONFIG.FILTERS.COMPETITORS_TYPES'), (val) => ({
                    text: val,
                    value: val
                })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        };

        const data = [{
            name: 'category_and_brands',
            data: _.reduce(environment.get('CONFIG.FILTERS.BRANDS_CLASSIFICATION_ACTIVE_NETWORK'), (acc, val, key) => {
                _.forEach(val, (v, i) => {
                    acc.push({
                        CD_CAT: key,
                        NM_CAT: translate(key),
                        CD_BRAND: v,
                        NM_BRAND: v
                    });
                });

                return acc;
            }, []),
            position: 1,
            visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterClassification),
            fields: [{
                title: translate('Common.Brand'),
                name: 'brands',
                value: 'CD_BRAND',
                text: 'NM_BRAND',
                group: 'NM_CAT',
                type: 'multiselect'
            }]
        }];

        if (environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Car) {
            data[0].fields.unshift({
                title: `${translate('Common.Classification')} ${translate('Common.Brand')}`,
                name: 'classification',
                value: 'CD_CAT',
                text: 'NM_CAT',
                skipAll: true,
                type: 'multiselect'
            });
        }

        data.push(typeFilter);

        data.push({
            name: 'group',
            position: 3,
            visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterGroup),
            fields: [{
                title: translate('Common.Group'),
                name: 'group',
                dataSource: _(environment.get('CONFIG.FILTERS.GROUPS_NAME'))
                    .map(val => ({ text: val.text, value: val.text }))
                    .orderBy(val => val)
                    .value(),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        if (this.options.showVMMCompetitors) {
            data.push({
                name: 'segment',
                position: 4,
                visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterSegment),
                fields: [{
                    title: translate('Common.Segment'),
                    name: 'segment',
                    dataSource: _.map(environment.get('CONFIG.FILTERS.SEGMENT'), (segment) => ({ text: translateText(segment.name, true), value: segment.id })),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        data.push({
            name: 'fuelType',
            position: 5,
            visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterFuelType),
            fields: [{
                title: translate('Common.FuelType'),
                name: 'fuelType',
                dataSource: _.map(environment.get('CONFIG.FILTERS.FUEL_TYPES'), (fuel) => ({ text: fuel.text, value: fuel.value })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        data.push({
            name: 'state',
            position: 6,
            visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterUf),
            fields: [{
                title: 'UF',
                name: 'state',
                dataSource: environment.get('CONFIG.STATES'),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        data.push({
            name: 'storeTypeSaleMarket',
            position: 7,
            visible: isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterStoreTypeSaleMarket),
            fields: [{
                title: translate('Common.FilterStoreTypeSalesMarket'),
                name: 'storeTypeSaleMarket',
                dataSource: _.map(environment.get('CONFIG.FILTERS.TYPE_SALES_MARKET'), (v) => ({ text: v.text, value: v.value })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        if (environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT')
            && environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT').length
            && this.options.showVMMCompetitors) {
            data.push({
                name: 'industry',
                position: 8,
                visible: true,
                fields: [{
                    title: translate('Common.Industry'),
                    name: 'industry',
                    dataSource: environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT'),
                    value: 'id',
                    text: 'name',
                    type: 'dropdown'
                }]
            });
        }

        if (environment.get('CONFIG.FILTERS.STORE_COMPETITORS_CONTEXT_ATTRIBUTES')
            && environment.get('CONFIG.FILTERS.STORE_COMPETITORS_CONTEXT_ATTRIBUTES').length > 0
            && isAuthorized(FeaturePermission.LAYER_COMPETITORS.filterStoreAttribute)) {
            data.push({
                name: 'attribute_context',
                position: 9,
                visible: true,
                data: environment.get('CONFIG.FILTERS.STORE_COMPETITORS_CONTEXT_ATTRIBUTES'),
                fields: [
                    {
                        title: translate('Common.StoreContextAttribute'),
                        name: 'attributes',
                        text: 'attributeName',
                        value: 'idAttributeType',
                        skipAll: true,
                        type: 'multiselect',
                    }
                ]
            });

            data
                .filter(d => d.name === 'attribute_context')
                .forEach(d => {
                    const contexts = environment.get('CONFIG.FILTERS.STORE_CONTEXT_ATTRIBUTES')
                        .map(x => x.idContextAttribute)
                        .reduce((acc, curr) => acc.add(curr), new Set());

                    if (contexts.length > 1) {
                        d.fields = [
                            {
                                title: translate('Common.StoreContext'),
                                name: 'contextAttributes',
                                text: 'attributeContextName',
                                value: 'idAttributeContext',
                                type: 'dropdown',
                            },
                            ...d.fields
                        ];
                    }
                });
        }

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/competitors.factory.js